import {charcoal} from '../../sass/v2/_exports.sass';

export const RedoIcon = ({color = charcoal, className = '', ratio = 1}) => {
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};
  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Redo</title>
      <path
        d="M12.8283 24.6667C10.8778 24.6667 9.20729 24.0137 7.81662 22.7077C6.42596 21.4017 5.73062 19.794 5.73062 17.8847C5.73062 15.9753 6.42596 14.3697 7.81662 13.068C9.20729 11.7662 10.8778 11.1153 12.8283 11.1153H22.1896L18.4796 7.405L19.8847 6L26 12.1153L19.8847 18.2307L18.4796 16.8257L22.1896 13.1153H12.8283C11.4367 13.1153 10.2393 13.5725 9.23595 14.4869C8.23241 15.4016 7.73062 16.5343 7.73062 17.8847C7.73062 19.2351 8.23241 20.3697 9.23595 21.2884C10.2393 22.2072 11.4367 22.6667 12.8283 22.6667H22.3973V24.6667H12.8283Z"
        fill={color}
      />
    </svg>
  );
};
